// ============================================
// USER DATA CONSUMER - Componente que consume el store userData
// ============================================

import Alpine from 'alpinejs';

export function registerUserDataConsumer() {
    Alpine.data('userDataConsumer', () => ({
        userData: null as any,
        loading: true,
        error: null as string | null,

        init() {
            // Verificar si ya hay datos en el store
            const store = (Alpine as any).store('userData');
            const result = store.getData();

            if (result.status === 'ready') {
                this.userData = result.data;
                this.loading = false;
            } else if (result.status === 'error') {
                this.error = result.error;
                this.loading = false;
            }

            // Escuchar evento cuando los datos se cargan
            window.addEventListener('user_data_loaded', (event: any) => {
                this.userData = event.detail;
                this.loading = false;
                this.error = null;
            });
        },

        // Helper para obtener todo el objeto o un valor específico
        get(key?: string) {
            if (!key) return this.userData;
            return this.userData?.[key];
        }
    }));
}
